import React from 'react';
import PropTypes from 'prop-types';
import RenderCheckBoxInputField from 'components/form/InputFields/RenderCheckBoxInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import authHelper from 'helpers/auth';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, Field, isInvalid } from 'redux-form';

class WebhooksEditForm extends React.Component {
    componentDidMount() {
        const {
            data,
            initialize,
        } = this.props;

        initialize({
            action_booking_cancelled: data.action_booking_cancelled,
            action_booking_created: data.action_booking_created,
            action_booking_initialised: data.action_booking_initialised,
            action_booking_modified: data.action_booking_modified,
            action_booking_under_review: data.action_booking_under_review,
            action_reservation_cancelled: data.action_reservation_cancelled,
            action_reservation_created: data.action_reservation_created,
            action_reservation_modified: data.action_reservation_modified,
            is_active: data.is_active,
            name: data.name,
            url: data.url,
        });
    }

    render() {
        const {
            handleSubmit,
            handleSubmitForm,
            invalid,
            submitting,
            translate,
        } = this.props;

        const isProvider = authHelper.isProvider();
        const isReseller = authHelper.isReseller();

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section title={ translate('resources.webhooks.forms.general') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.webhooks.fields.name') }
                                    name='name'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.webhooks.fields.url') }
                                    name='url'
                                    validate={ [
                                        validations.required,
                                        validations.url,
                                    ] }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderCheckBoxInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.webhooks.fields.is_active') }
                                    name='is_active'
                                />
                            </Item>
                        </Row>
                    </Section>

                    { isReseller &&
                        <Section title={ translate('resources.webhooks.forms.actions') }>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_created') }
                                        name='action_booking_created'
                                    />
                                </Item>
                            </Row>

                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_modified') }
                                        name='action_booking_modified'
                                    />
                                </Item>
                            </Row>

                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_cancelled') }
                                        name='action_booking_cancelled'
                                    />
                                </Item>
                            </Row>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_initialised') }
                                        name='action_booking_initialised'
                                        type='text'
                                    />
                                </Item>
                            </Row>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_booking_under_review') }
                                        name='action_booking_under_review'
                                        type='text'
                                    />
                                </Item>
                            </Row>
                        </Section>
                    }

                    { isProvider &&
                        <Section title={ translate('resources.webhooks.forms.actions') }>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_reservation_created') }
                                        name='action_reservation_created'
                                    />
                                </Item>
                            </Row>

                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_reservation_modified') }
                                        name='action_reservation_modified'
                                    />
                                </Item>
                            </Row>

                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderCheckBoxInputField }
                                        fullWidth={ true }
                                        label={ translate('resources.webhooks.fields.action_reservation_cancelled') }
                                        name='action_reservation_cancelled'
                                    />
                                </Item>
                            </Row>
                        </Section>
                    }

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

WebhooksEditForm.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm(),
);

export default enhance(WebhooksEditForm);



// WEBPACK FOOTER //
// ./src/pages/webhooks/edit/WebhooksEditForm.js